const MAX_BOOK_WIDTH = 200
const DEFAULT_BOOK_WIDTH = 168
const DEFAULT_ASPECT_RATIO = 3 / 4

export function useBookImageStyle () {
  const getBookImageStyle = book => {
    if (book?.imageCropDimensions) {
      const { width, height } = book.imageCropDimensions
      if (width === 0 || height === 0) {
        return {
          aspectRatio: `${DEFAULT_ASPECT_RATIO}`
        }
      }
      const aspectRatio = width / height
      return {
        aspectRatio: `${aspectRatio}`
      }
    }
    return {
      aspectRatio: `${DEFAULT_ASPECT_RATIO}`
    }
  }

  const getBookImageContainerStyle = book => {
    if (book?.imageCropDimensions) {
      const { width, height } = book.imageCropDimensions
      if (width === 0 || height === 0) {
        return {
          width: `${DEFAULT_BOOK_WIDTH}px`,
          height: `${DEFAULT_BOOK_WIDTH / DEFAULT_ASPECT_RATIO}px`
        }
      }

      let displayWidth = width
      let displayHeight = height

      if (width > MAX_BOOK_WIDTH) {
        const scale = MAX_BOOK_WIDTH / width
        displayWidth = MAX_BOOK_WIDTH
        displayHeight = height * scale
      }

      return {
        width: `${displayWidth}px`,
        height: `${displayHeight}px`
      }
    }
    return {
      width: `${DEFAULT_BOOK_WIDTH}px`,
      height: `${DEFAULT_BOOK_WIDTH / DEFAULT_ASPECT_RATIO}px`
    }
  }

  return {
    getBookImageStyle,
    getBookImageContainerStyle,
    MAX_BOOK_WIDTH,
    DEFAULT_BOOK_WIDTH
  }
}
